
import { message } from "antd";
import FetchData from '@ezviz/FetchData';
import Cookies from "js-cookie";
import util from './../../utils/utils';
import moment from 'moment';
export const UPDATE_STAT_LOADING_STATUS = "UPDATE_STAT_LOADING_STATUS";

export const GET_ALL_PRODUCR_LIST = "GET_ALL_PRODUCR_LIST";
export const GET_ALL_APP_LIST = "GET_ALL_APP_LIST";
export const GET_REGISTER_USER = "GET_REGISTER_USER";
export const GET_REGISTER_USER_CHAIN = "GET_REGISTER_USER_CHAIN";
export const GET_REGISTER_USER_SUM = "GET_REGISTER_USER_SUM";

export const GET_LIVELY_USER = "GET_LIVELY_USER";
export const GET_LIVELY_USER_CHAIN = "GET_LIVELY_USER_CHAIN";
export const GET_LIVELY_USER_SUM = "GET_LIVELY_USER_SUM";

export const GET_LIVELY_DEVICE = "GET_LIVELY_DEVICE";
export const GET_LIVELY_DEVICE_CHAIN = "GET_LIVELY_DEVICE_CHAIN";
export const GET_LIVELY_DEVICE_SUM = "GET_LIVELY_DEVICE_SUM";

export const GET_ACTIVE_DEVICE = "GET_ACTIVE_DEVICE";
export const GET_ACTIVE_DEVICE_CHAIN = "GET_ACTIVE_DEVICE_CHAIN";
export const GET_ACTIVE_DEVICE_SUM = "GET_ACTIVE_DEVICE_SUM";

message.config({
  top: 300,
  maxCount: 1
});

/**
 * 初始化数据，随机生成数据
 * @param {*} period 
 */
const initData = (unit = 1000) => {
  const DATA = [];
  for (let i = 1; i <= 30; i++) {
    DATA.push({
      date: moment.utc().subtract(i, 'days').format('YYYY-MM-DD'),
      count: parseInt(Math.random() * unit)
    });
  }
  return DATA.reverse();
}
/**
 * 随机初始化数据转换同比环比数据
 */
const chainData = (orignData) => {
  const DATA = [];
  orignData.map((v, index) => {
    DATA.push({
      date: v.date,
      count: index == 0 ? Math.random() : ((orignData[index].count - orignData[index - 1].count) / (orignData[index - 1].count == 0 ? 1 : orignData[index - 1].count)),
      count7: index < 7 ? Math.random() : ((orignData[index].count - orignData[index - 7].count) / (orignData[index - 7].count == 0 ? 1 : orignData[index - 7].count)),
      count30: v.count != 0 ? Math.random() : -1
    })
  })
  console.log(DATA)
  return DATA;
}

/**
 * 随机初始化数据转换汇总数据
 */
const sumData = (orignData) => {
  const DATA = [];
  let yesterdayCount = 0, weekCount = 0, monthCount = 0, count = 0;
  for (let i = orignData.length - 1; i > 0; i--) {
    if (i == orignData.length - 1) {
      yesterdayCount = orignData[i].count;
    }
    if (i <= orignData.length - 1 && i >= orignData.length - 7) {
      weekCount += orignData[i].count;
    }
    monthCount += orignData[i].count;
    count = monthCount + parseInt(Math.random() * 10000)
  }
  DATA.push({
    count,
    monthCount,
    weekCount,
    yesterdayCount
  })
  return DATA;
}

/**
 * 触发数据存储store
 * @param {*} dispatch 
 * @param {*} type 
 * @param {*} params 
 * @param {*} data 
 */
const TransData = (dispatch, type, params, data) => {
  const isDemo = util.getStorage(`EZIOT_DEMO_${Cookies.get("userName")}`) || 0;
  switch (type) {
    case 'iotopen.userreg':// 注册用户数
      dispatch({
        type: GET_REGISTER_USER,
        registerUsers: data[type] || (isDemo == 1 ? randomData : [])
      });
      break;
    case 'iotopen.userregchain':// 注册用户数同比
      dispatch({
        type: GET_REGISTER_USER_CHAIN,
        registerUsersChain: data[type] || (isDemo == 1 ? chainData(randomData) : [])
      });
      break;
    case 'iotopen.userregsum':// 注册用户数汇总
      dispatch({
        type: GET_REGISTER_USER_SUM,
        registerUsersSum: data[type] || (isDemo == 1 ? sumData(randomData) : [])
      });
      break;

    case 'iotopen.userlogin':// 活跃用户数
      dispatch({
        type: GET_LIVELY_USER,
        livelyUsers: data[type] || (isDemo == 1 ? randomData : [])
      });
      break;
    case 'iotopen.userloginchain':// 活跃用户数同比
      dispatch({
        type: GET_LIVELY_USER_CHAIN,
        livelyUsersChain: data[type] || (isDemo == 1 ? chainData(randomData) : [])
      });
      break;
    case 'iotopen.userloginsum':// 活跃用户数汇总
      dispatch({
        type: GET_LIVELY_USER_SUM,
        livelyUsersSum: data[type] || (isDemo == 1 ? sumData(randomData) : [])
      });
      break;

    case 'iotopen.deviceactivate':// 激活设备数
      dispatch({
        type: GET_ACTIVE_DEVICE,
        activeDevices: data[type] || (isDemo == 1 ? randomData : [])
      });
      break;
    case 'iotopen.deviceactivatechain':// 设备激活同比
      dispatch({
        type: GET_ACTIVE_DEVICE_CHAIN,
        activeDeviceChain: data[type] || (isDemo == 1 ? chainData(randomData) : [])
      });
      break;
    case 'iotopen.deviceactivatesum':// 激活设备数汇总
      dispatch({
        type: GET_ACTIVE_DEVICE_SUM,
        activeDevicesSum: data[type] || (isDemo == 1 ? sumData(randomData) : [])
      });
      break;

    case 'iotopen.devicealive':// 活跃设备数
      dispatch({
        type: GET_LIVELY_DEVICE,
        livelyDevices: data[type] || (isDemo == 1 ? randomData : [])
      });
      break;
    case 'iotopen.devicealivechain':// 活跃设备数同比
      dispatch({
        type: GET_LIVELY_DEVICE_CHAIN,
        livelyDeviceChain: data[type] || (isDemo == 1 ? chainData(randomData) : [])
      });
      break;
    case 'iotopen.devicealivesum':// 活跃设备数汇总
      dispatch({
        type: GET_LIVELY_DEVICE_SUM,
        livelyDevicesSum: data[type] || (isDemo == 1 ? sumData(randomData) : [])
      });
      break;

    case 'iotopen.app':// 应用列表
      dispatch({
        type: GET_ALL_APP_LIST,
        appList: data[type] || []
      });
      break;
    case 'iotopen.product':// 产品列表
      dispatch({
        type: GET_ALL_PRODUCR_LIST,
        productList: data[type] || []
      });
      break;
  }
}

// 随机数
let randomData = initData();

/**
 * 获取数据
 * @param {*} params 
 * @param {*} callback 
 * @param {*} failback 
 */
export function getReportData(params, callback, failback) {
  return (dispatch, getState) => {
    dispatch(updateLoadingStatus(true));
    const isDemo = util.getStorage(`EZIOT_DEMO_${Cookies.get("userName")}`) || 0;
    const reportNameList = params.reportName.split(',');
    //重新加载页面，需要获取app或产品列表
    if (params.reportName == 'iotopen.app' || params.reportName == 'iotopen.product' || params.pid || params.appId) {
      randomData = initData();// 重新生成随机数
    }

    if (isDemo == 1 && !(params.reportName == 'iotopen.app' || params.reportName == 'iotopen.product')) {
      reportNameList.map(v => {
        setTimeout(() => { dispatch(updateLoadingStatus(false)); }, 300)
        TransData(dispatch, v, params, {})
      })
    } else {
      const url = '/iot/config/bigdata/report/data';
      const fetchData = new FetchData(url, {
        method: "GET",
        body: params,
        metaHandler: {
          403: () => { window.location.href = '/authrization/login'; return; }
        },
      });
      fetchData
        .then(res => {
          setTimeout(() => { dispatch(updateLoadingStatus(false)); }, 300)
          if (res.meta.code === 0) {
            callback && callback();
            const { data = { list: [] } } = res;
            reportNameList.map(v => {
              TransData(dispatch, v, params, data)
            })
          } else {
            message.error(res.meta.message || '加载失败，请重试~');
            failback && failback();
          }
        })
        .catch(e => {
          setTimeout(() => { dispatch(updateLoadingStatus(false)); }, 300)
          message.error('加载失败，请重试~');
          failback && failback();
        });
    };
  }
}

export function updateLoadingStatus(loading) {
  return (dispatch, getState) => {
    dispatch({
      type: UPDATE_STAT_LOADING_STATUS,
      loading
    });
  };
}
